import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSpeedHigh: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconSpeedHigh"><Path d="M17.1256 20C19.7568 18.3107 21.5 15.3589 21.5 12C21.5 6.75329 17.2467 2.5 12 2.5C6.75329 2.5 2.5 6.75329 2.5 12C2.5 15.3589 4.24324 18.3107 6.87436 20" stroke="currentColor"/><Path d="M10.468 14.2846C9.75795 13.4385 9.86832 12.177 10.7145 11.467C11.5606 10.757 12.8221 10.8673 13.5321 11.7135C15.1391 13.6286 15.8568 17.5953 15.8568 17.5953C15.8568 17.5953 12.0749 16.1998 10.468 14.2846Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSpeedHigh;
